var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockAcc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unlock_acc",
    transform: "translate(106 -8111)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 64,
    height: 64,
    transform: "translate(-106 8111)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cfde929122150d98f45f879fd1f3ec89",
    transform: "translate(-105.439 7016.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    width: 60,
    height: 60,
    rx: 5.494,
    transform: "translate(1.439 1096.636)",
    fill: "#017f99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24630",
    "data-name": "Path 24630",
    d: "M20.662,1102.23a6.965,6.965,0,0,0-6.952,6.952v4.807a11.639,11.639,0,1,0,7.2-2.4,1.2,1.2,0,0,0-.187,0,11.594,11.594,0,0,0-4.68.993v-3.4a4.581,4.581,0,0,1,4.615-4.615h.127a4.579,4.579,0,0,1,4.615,4.615,1.172,1.172,0,0,0,2.345,0,6.97,6.97,0,0,0-6.96-6.955h-.125Zm.065,11.694a9.361,9.361,0,1,1-5.291,1.641,1.013,1.013,0,0,0,.095-.06c.127-.085.267-.145.4-.225a9.774,9.774,0,0,1,.918-.5c.217-.1.447-.175.671-.259a9.5,9.5,0,0,1,.963-.3c.195-.045.389-.095.586-.13a9.072,9.072,0,0,1,1.659-.165Zm0,4.68a3.5,3.5,0,0,0-1.17,6.8v4.892H21.9v-4.892a3.5,3.5,0,0,0-1.17-6.8Zm0,2.337a1.143,1.143,0,0,1,1.17,1.173,1.171,1.171,0,1,1-2.342,0A1.145,1.145,0,0,1,20.726,1120.942Z",
    transform: "translate(10.714 8.04)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockAcc);
export default __webpack_public_path__ + "static/media/unlock_acc.18e660ea2cd58d18fa88b40ca570395a.svg";
export { ForwardRef as ReactComponent };